import { useState } from "react";
import { FaArrowRight } from "react-icons/fa";

const DROPDOWN_OPTIONS = [
  {
    index: 0,
    title: "De la idea a la acción",
    desplegable: [
      "Valoramos la capacidad de ejecutar proyectos y tareas de manera efectiva y eficiente. La ejecución implica no solo planificar y diseñar soluciones, sino tambien implementar y concretar esas ideas para obtener resultados tangibles.",
    ],
  },
  {
    index: 1,
    title: "Mentalidad startup",
    desplegable: [
      "Nos gusta probar, aprender rápido y mejorar sobre la marcha. Nos adaptamos al cambio como quien cambia de surco en el campo.",
    ],
  },
  {
    index: 2,
    title: "Resultados que se notan",
    desplegable: [
      "Destacamos la importancia de los resultados sobre los procesos. Los procesos importan, sí. Pero lo que nos mueve son los resultados. Este valor subraya que, aunque los métodos y procedimientos son importantes, lo que realmente nos importa al final del día son los resultados obtenidos.",
    ],
  },
  {
    index: 3,
    title: "Tomá la posta",
    desplegable: [
      "Nos hacemos cargo. Cada uno se adueña de lo que hace y lo empuja con responsabilidad. Eso nos hace crecer como personas, como equipo y como empresa.",
    ],
  },
];

export const Valores = () => {
  const [openIndexes, setOpenIndexes] = useState([]);

  const handleDesplegables = (index) => {
    setOpenIndexes((prevState) => {
      let array = [...prevState];

      if (array.includes(index)) {
        array = array.filter((indice) => indice !== index);
      } else {
        array.push(index);
      }

      return array;
    });
  };
  return (
    <section className="valores-background">
      <img
        src={`${process.env.PUBLIC_URL}/assets/imagenes/home/fondo_puntitos.png`}
        className="background-dots"
        alt="background"
      />
      <div
        className="meet-wrapper"
        style={{ marginBlock: "2rem" }}
        id="join-us"
      >
        <div
          className="meet-box"
          style={{
            backgroundColor: "var(--red-highlight)",
            color: "white",
          }}
        >
          <p className="meet-title">
            Conocé al increíble equipo detrás de binamics <br />y oportunidades
            laborales
          </p>
          {/* <p className="color-card-subtitle">
          convierte interacciones en conocimientos que impulsan tu negocio.
        </p> */}
          <span className="horizontal gap-16">
            <a
              href="https://www.linkedin.com/company/binamics"
              target="_blank"
              rel="noreferrer"
            >
              <button
                className="boton-generico boton-rojo"
                style={{ borderColor: "white" }}
              >
                <p>LinkedIn</p>
                <FaArrowRight />
              </button>
            </a>
            {/* <button
              className="boton-generico boton-rojo"
              style={{ borderColor: "white" }}
            >
              <p>Sumate a nuestro equipo</p>
              <FaArrowRight />
            </button> */}
          </span>
        </div>
      </div>

      <div
        className="columna"
        style={{ paddingLeft: "10%", marginTop: "8rem" }}
      >
        <span className="horizontal gap-8" style={{ marginBottom: 24 }}>
          <span
            className="linea-blanca"
            style={{ backgroundColor: "white" }}
          ></span>
          <p className="datos-upper-text" style={{ color: "white" }}>
            Nuestro ADN
          </p>
        </span>

        <p className="section-title" style={{ color: "white" }}>
          <span>
            Los <span style={{ color: "var(--red-highlight)" }}> valores</span>
            <br />
            que guian todo
            <br />
            lo que hacemos
          </span>
        </p>

        <span className="section-subtitle" />
      </div>
      <div className="valores-menu">
        {DROPDOWN_OPTIONS.map((element, index) => {
          const open = openIndexes?.includes(element.index);

          return (
            <span
              className="valores-menu-item"
              key={element.index}
              onClick={() => handleDesplegables(element.index)}
            >
              <span
                className="horizontal"
                style={{
                  width: "100%",
                  fontSize: "1.75rem",
                }}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/assets/imagenes/home/icoflechatop.png`}
                  className={
                    !open ? "valores-dropdown-right" : "valores-dropdown-down"
                  }
                  //   className="image-go-top pointer"
                  alt="boton-desplegar"
                  //   onClick={scrollToTop}
                />
                <p
                  style={{
                    fontWeight: 500,
                    marginLeft: "2rem",
                    color: "white",
                  }}
                >
                  {element.title}
                </p>
              </span>
              {open && (
                <span className="dropdown-content">
                  <p>{element.desplegable[0]}</p>
                </span>
              )}
            </span>
          );
        })}
      </div>

      <img
        alt="mujer-observadora"
        src={`${process.env.PUBLIC_URL}/assets/imagenes/about/mujerobservadora-13.png`}
        style={{ position: "absolute", bottom: -8, right: -8, width: "45%" }}
      />
    </section>
  );
};
